module.exports = __webpack_public_path__ + "static/media/Compare.d0b12088.svg";